module.exports = __webpack_public_path__ + "static/media/step-6.d64cef45.svg";